import { Modal, Pressable, StyleSheet, Text, View } from 'react-native'

import { colors } from '../../../theme'
import { label1, label2 } from '../../../theme/typography'

interface ExerciseGoalEditModalProps {
  visible: boolean
  selectedValue: number
  onSelectValue: (value: number) => void
  onRequestClose: () => void
  title: string
  isSaving?: boolean
}

const GOAL_OPTIONS = [1, 2, 3, 4, 5, 6, 7] as const

export function ExerciseGoalEditModal({
  visible,
  selectedValue,
  onSelectValue,
  onRequestClose,
  title,
  isSaving = false,
}: ExerciseGoalEditModalProps) {
  return (
    <Modal
      transparent
      visible={visible}
      animationType="fade"
      onRequestClose={onRequestClose}
    >
      <View className="flex-1 justify-center px-4">
        <Pressable
          className="absolute inset-0 bg-black/30"
          onPress={onRequestClose}
          disabled={isSaving}
        />

        <View className="rounded-2xl" style={styles.modal}>
          <Text style={styles.title}>{title}</Text>

          <View className="mt-4 flex-row justify-between">
            {GOAL_OPTIONS.map((option) => {
              const isSelected = selectedValue === option

              return (
                <Pressable
                  key={option}
                  disabled={isSaving}
                  onPress={() => onSelectValue(option)}
                  style={[
                    styles.option,
                    isSelected
                      ? styles.optionSelected
                      : styles.optionUnselected,
                    isSaving ? styles.optionSaving : null,
                  ]}
                >
                  <Text style={styles.optionLabel}>{option}</Text>
                </Pressable>
              )
            })}
          </View>
        </View>
      </View>
    </Modal>
  )
}

const styles = StyleSheet.create({
  modal: {
    backgroundColor: colors.backgroundPrimary,
    paddingHorizontal: 16,
    paddingTop: 16,
    paddingBottom: 18,
  },
  title: {
    ...label1,
    color: colors.textHeader,
  },
  option: {
    width: 40,
    height: 40,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 1,
  },
  optionSelected: {
    borderColor: '#706C9D',
    backgroundColor: colors.secondary700,
  },
  optionUnselected: {
    borderColor: colors.grayMid,
    backgroundColor: colors.backgroundSecondary,
  },
  optionSaving: {
    opacity: 0.6,
  },
  optionLabel: {
    ...label2,
    color: colors.textHeader,
    textAlign: 'center',
    textAlignVertical: 'center',
    includeFontPadding: false,
    transform: [{ translateY: 1 }],
  },
})
